import MotivationSection from './motivation-section';

export default MotivationSection;
